
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'2-8'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            메인화면 관리 - 탑 배너 관리
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              수정
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='top_banner_title'>타이틀<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'top_banner_title'
                maxLength="50"
                placeholder = "타이틀을 입력해 주세요.(50자 이내)"
                v-model="formData.topBannerTitle"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.topBannerTitleError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='top_banner_status'>사용 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="top_banner_status"
                v-model="formData.topBannerStatus"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
          </div>

          <div class="Admin_editorBox_BoxWrap">
            <div class="Admin_editorBox_BoxTit">
              PC용 에디터
              <span> (스크린 최소 사이즈 기준 1200px)</span>
            </div>
            <custom-textarea
              v-model="formData.topBannerEditor"
              :id="'top_banner_editor'"
            />
          </div>

           <div class="Admin_editorBox_BoxWrap">
            <div class="Admin_editorBox_BoxTit">
              모바일용 에디터
              <span> (스크린 최소 사이즈 기준 480px)</span>
            </div>
            <custom-textarea
              v-model="formData.topBannerMobileEditor"
              :id="'top_banner_mobile_editor'"
              style="width:480px;"
            />
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import CustomTextarea from '../../ETC/CustomTextarea.vue'
import {
  get_top_banner_one,
  update_top_banner
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminTopBannerManagement',
  components: {
    AdminHeader: AdminHeader,
    AdminFooter: AdminFooter,
    Spiner: Spiner,
    CustomTextarea
  },
  setup () {
    return {
      formData: ref({
        topBannerTitle: '',
        topBannerStatus: 1,
        topBannerEditor: '',
        topBannerMobileEditor: ''
      }),
      errorData: ref({
        topBannerTitleError: ''
      }),
      statusData: ref({
        spinnerStatus: false
      })
    }
  },
  methods: {
    check_form: function () {
      let continue_add = true
      if (this.formData.topBannerTitle === '') {
        this.errorData.topBannerTitleError = '타이틀을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.topBannerTitleError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        update_top_banner(
          this.formData.topBannerTitle,
          this.formData.topBannerStatus,
          this.formData.topBannerEditor,
          this.formData.topBannerMobileEditor
        ).then(() => {
          this.statusData.spinnerStatus = false
          alert('수정이 완료되었습니다.')
        })
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    get_top_banner_one().then((result) => {
      this.formData.topBannerTitle = result[0].top_banner_title
      this.formData.topBannerStatus = String(result[0].top_banner_status)
      this.formData.topBannerEditor = result[0].top_banner_editor
      this.formData.topBannerMobileEditor = result[0].top_banner_mobile_editor
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/MainManagement/AdminTopBannerManagement.vue